import React, { useState, useEffect } from "react";
import { useMusic } from "../../../context/MusicContext";
import DancingBar from "../dancingBar/DancingBar";

const ProgressBar = ({ musicRef, musicData, setIsLoading }) => {
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [currentTimeInFormat, setCurrentTimeInFormat] = useState(0);
  const [durationFormat, setDurationFormat] = useState(0);
  const [progress, setProgress] = useState(0);

  const musicContext = useMusic();

  const secondsToMinutesAndSeconds = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    const formattedMinutes = minutes < 10 ? `${minutes}` : minutes;
    const formattedSeconds =
      remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds;

    return `${formattedMinutes}:${formattedSeconds}`;
  };



  useEffect(() => {
    if (musicData.id === musicContext.song.id) {
      const audioElement = musicRef.current;
      const handleTimeUpdate = () => {
        setCurrentTime(audioElement.currentTime);
        setCurrentTimeInFormat(
          secondsToMinutesAndSeconds(audioElement.currentTime)
        );
        setProgress((currentTime / duration) * 100);
      };

      const handleLoadedMetadata = () => {
        // setCurrentTime(audioElement.currentTime);
        setDuration(audioElement.duration);
        setDurationFormat(secondsToMinutesAndSeconds(audioElement.duration));
        setProgress((currentTime / duration) * 100);
      };

      const handleEnded = () => {
        // musicContext.pauseAudio();
        setCurrentTime(0);
        setProgress(0);
        setDuration(0);
        setCurrentTimeInFormat(secondsToMinutesAndSeconds(0));
      };
      handleLoadedMetadata();
      audioElement.addEventListener("timeupdate", handleTimeUpdate);
      audioElement.addEventListener("loadedmetadata", handleLoadedMetadata);
      audioElement.addEventListener("ended", handleEnded);

      return () => {
        audioElement.removeEventListener("timeupdate", handleTimeUpdate);
        audioElement.removeEventListener(
          "loadedmetadata",
          handleLoadedMetadata
        );
        audioElement.removeEventListener("ended", handleEnded);
      };
    }
  }, [musicRef.current.currentTime, musicContext.song.id, musicData]);

  useEffect(() => {
    if (musicData.id !== musicContext.song.id || !musicContext.song.id) {
      const audio = new Audio(musicData.audio_url);
      audio.addEventListener("loadedmetadata", () => {
        // The duration is available once the metadata is loaded
        const durationInSeconds = audio.duration;
        setDurationFormat(secondsToMinutesAndSeconds(durationInSeconds));
        setDuration(0);
        /** change parent (player) state from this **/
        setIsLoading(false);
      });
      setCurrentTimeInFormat(secondsToMinutesAndSeconds(0));
      setCurrentTime(0);
      setProgress(0);
    } else {
      setCurrentTime(musicRef.current.currentTime);
      setDuration(musicRef.current.duration);
      const currTime = musicRef.current.currentTime;
      const dur = musicRef.current.duration;
      setProgress((currTime / dur) * 100);
      setIsLoading(true);
    }
  }, []);

  const handleProgressBarClick = (event) => {
    const progressBar = event.currentTarget;
    const percentageClicked =
      (event.nativeEvent.offsetX / progressBar.offsetWidth) * 100;

    if (!isNaN(percentageClicked) && isFinite(percentageClicked)) {
      const newTime = (percentageClicked / 100) * musicRef.current.duration;

      if (!isNaN(newTime) && isFinite(newTime)) {
        setProgress(percentageClicked);
        // musicRef.current.play();
        // setPlay(true) // play the music
        musicRef.current.currentTime = newTime;
      }
    }
  };

  return (
    <>
      <div className="relative mt-4">
      {/* <DancingBar /> */}
        <div
          className="bg-slate-700 transition-all duration-500 dark:bg-slate-700 rounded-full overflow-hidden"
          onClick={handleProgressBarClick}
        >
          <div
            className="bg-yellow-300 transition-all duration-500 dark:bg-yellow-300  rounded-full h-2 ring-1 ring-slate-900/5"
            role="progressbar"
            aria-label="music progress"
            aria-valuenow={progress}
            aria-valuemin="0"
            aria-valuemax="100"
            style={{ width: `${progress}%` }}
          ></div>
        </div>
      </div>
      <div className="flex justify-between text-sm leading-6 font-medium tabular-nums">
        <div className="text-cyan-500 transition-all duration-500 dark:text-slate-100">
          {musicContext.song.id ? currentTimeInFormat : "0:00"}
        </div>
        <div className="text-slate-500 transition-all duration-500 dark:text-slate-400">
          { durationFormat ? durationFormat :  "0:00"}
        </div>
      </div>
    </>
  );
};

export default ProgressBar;
